import Debug from 'debug';
import { EventEmitter } from 'events';
import { Events } from './interface';
import { P2PMediaManager } from './p2p-manager';
import { SegmentsMemoryStorage } from './segments-memory-storage';
const defaultSettings = {
    cachedSegmentsCount: 30,
    p2pSegmentDownloadTimeout: 60000,
    webRtcMaxMessageSize: 64 * 1024 - 1,
    trackerAnnounce: ['wss://live-wt-tracker.test.seewo.com', 'wss://tracker.webtorrent.dev'],
    peerRequestsPerAnnounce: 10,
    rtcConfig: {
        iceServers: [
            {
                urls: [
                    'stun:stun.qq.com:3478',
                    'stun:stun.miwifi.com:3478',
                    'stun:stun.chat.bilibili.com:3478',
                    'stun:stun.syncthing.net:3478',
                    'stun:stun.cloudflare.com:3478',
                    'stun:stun.l.google.com:19302',
                    'stun:global.stun.twilio.com:3478',
                ],
            },
        ],
        sdpSemantics: 'unified-plan',
    },
};
export class P2PEngine extends EventEmitter {
    constructor(swarmId, settings) {
        super();
        this.debug = Debug('p2pEngine:');
        this.onSegmentLoaded = (segment, data, peerId) => {
            this.storeSegment(segment);
            this.debug('segment loaded', segment.id, segment.url, peerId);
            segment.data = data;
            this.emit(Events.SegmentLoaded, segment, peerId);
        };
        this.onSegmentError = (segment, details, peerId) => {
            this.debug('segment error', segment.id, segment.url, peerId, details);
            this.emit(Events.SegmentError, segment, details, peerId);
        };
        this.onPeerSegmentsMapUpdated = ({ peerId, segmentsMap }) => {
            this.debug('peer segments map updated', peerId, segmentsMap);
        };
        this.onPeerConnect = async (peer) => {
            this.debug('peer connected', peer.id);
            this.emit(Events.PeerConnect, peer);
        };
        this.onPeerClose = (peerId) => {
            this.debug('peer closed', peerId);
            this.emit(Events.PeerClose, peerId);
        };
        this.onTrackerUpdate = async (data) => {
            this.debug('tracker update', data);
            this.broadcastSegmentsMap();
        };
        this.destroy = async () => {
            this.p2pManager.destroy();
            this.segmentsStorage.destroy();
            this.removeAllListeners();
        };
        this.swarmId = swarmId;
        this.settings = Object.assign(Object.assign({}, defaultSettings), settings);
        this.segmentsStorage = this.settings.segmentsStorage === undefined ? new SegmentsMemoryStorage(this.settings) : this.settings.segmentsStorage;
        this.p2pManager = new P2PMediaManager(this.swarmId, this.settings, this.segmentsStorage);
        this.p2pManager.on('segment-loaded', this.onSegmentLoaded);
        this.p2pManager.on('segment-error', this.onSegmentError);
        this.p2pManager.on('peer-connected', this.onPeerConnect);
        this.p2pManager.on('peer-closed', this.onPeerClose);
        this.p2pManager.on('tracker-update', this.onTrackerUpdate);
        this.p2pManager.on('peer-segments-map-updated', this.onPeerSegmentsMapUpdated);
    }
    getPeerId() {
        return this.p2pManager.getPeerId();
    }
    getPeers() {
        return this.p2pManager.getPeers();
    }
    getSettings() {
        return this.settings;
    }
    storeSegment(segment) {
        this.segmentsStorage.storeSegment(segment);
        this.broadcastSegmentsMap();
    }
    broadcastSegmentsMap() {
        const storageSegments = this.segmentsStorage.getSegments();
        const segmentsMap = storageSegments.map((x) => x.id).join('|');
        this.p2pManager.sendSegmentsMapToAll(segmentsMap);
    }
}
P2PEngine.isSupported = () => {
    return window.RTCPeerConnection.prototype.createDataChannel !== undefined;
};
